/**
 * Node modules
 */
import styled from 'styled-components';

/**
 * Private modules
 */
import { scale } from '../.private';

/**
 * Styled components
 */
const getStyles = (props) => {
  const { mode } = props;
  const styles = [];
  switch (mode) {
    case 'hidden': {
      styles.push('height: 0;');
      styles.push('margin-left: 0;');
      styles.push('visibility:hidden;');
      styles.push('width: 0;');
      break;
    }
    default: {
      styles.push(`margin-left: ${scale.major(2)}px;`);
      styles.push(`margin-top: ${scale.major(2)}px;`);
      break;
    }
  }
  return styles.join('');
};

export default styled.div`
  /* stylelint-disable */
  ${getStyles};
  /* stylelint-enable */
  align-items: center;
  display: flex;
  flex-wrap: wrap;
`;
